// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".page {\n  background-color: blue;\n}\n", "",{"version":3,"sources":["application.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB","file":"application.css","sourcesContent":[".page {\n  background-color: blue;\n}\n"]}]);
// Exports
module.exports = exports;
